import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Fragment as _Fragment, Transition as _Transition } from "vue";
import _imports_0 from '@/assets/EnableWhatapp.png';
import _imports_1 from '@/assets/check-tick.svg';
const _hoisted_1 = {
    key: 0,
    class: "settings-page"
};
const _hoisted_2 = { class: "settings-card" };
const _hoisted_3 = { class: "settings-row" };
const _hoisted_4 = { class: "settings-row-left" };
const _hoisted_5 = ["src"];
const _hoisted_6 = {
    key: 1,
    class: "employer-dot"
};
const _hoisted_7 = { class: "settings-row-value" };
const _hoisted_8 = { class: "settings-row-left" };
const _hoisted_9 = ["src"];
const _hoisted_10 = { class: "settings-row-left" };
const _hoisted_11 = ["src"];
const _hoisted_12 = { class: "settings-row-left" };
const _hoisted_13 = { class: "settings-row-right" };
const _hoisted_14 = ["src"];
const _hoisted_15 = ["src"];
const _hoisted_16 = { class: "month-view-segmented" };
const _hoisted_17 = { class: "whatsapp-section" };
const _hoisted_18 = { class: "settings-card" };
const _hoisted_19 = { class: "settings-row-left" };
const _hoisted_20 = ["src"];
const _hoisted_21 = {
    key: 0,
    src: _imports_1,
    alt: "",
    class: "cache-tick"
};
const _hoisted_22 = { class: "settings-row" };
const _hoisted_23 = { class: "settings-row-left" };
const _hoisted_24 = { class: "settings-row" };
const _hoisted_25 = { class: "settings-row-left" };
const _hoisted_26 = { class: "settings-row-right" };
const _hoisted_27 = ["src"];
const _hoisted_28 = { class: "settings-row-left" };
const _hoisted_29 = {
    key: 0,
    class: "settings-card"
};
const _hoisted_30 = { class: "settings-row-left" };
const _hoisted_31 = ["src"];
const _hoisted_32 = {
    key: 1,
    class: "settings-card"
};
const _hoisted_33 = { class: "settings-row" };
const _hoisted_34 = { class: "settings-row-left" };
const _hoisted_35 = { class: "settings-row" };
const _hoisted_36 = { class: "settings-row-left" };
const _hoisted_37 = { class: "settings-row" };
const _hoisted_38 = { class: "settings-row-left" };
const _hoisted_39 = { class: "settings-row" };
const _hoisted_40 = { class: "settings-row-left" };
const _hoisted_41 = { class: "settings-footer" };
const _hoisted_42 = { class: "settings-footer-version" };
const _hoisted_43 = { class: "hide-drawer-content" };
const _hoisted_44 = { class: "hide-drawer-content" };
import { ref, computed, watch, onMounted, getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useWhatsApp } from '@/composables/useWhatsApp';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
import SimpleDrawerPanel from './elements/SimpleDrawerPanel.vue';
import MGToggle from './elements/MGToggle.vue';
import WhatsAppEnableDrawer from './elements/WhatsAppEnableDrawer.vue';
import { checkIsAdmin } from '../utils/authUtils';
import { snapToSpendingCycle } from './elements/spendingAnalysisFilterState';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AppSettingsPage',
    setup(__props) {
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer, getEmployer } = useCustomer();
        const { enableWhatsApp } = useWhatsApp();
        const instance = getCurrentInstance();
        const cookies = instance?.appContext.config.globalProperties.$cookies;
        const wellKnownLogosOnlyGlobal = instance?.appContext.config.globalProperties.$wellKnownLogosOnly;
        const whatsAppEnableDrawer = ref(null);
        const randomiseOpen = ref(false);
        const spendingCycleInfoOpen = ref(false);
        const showLogoutConfirm = ref(false);
        const cacheCleared = ref(false);
        const randomiseFigures = ref(localStorage.getItem('randomiseFigures') === 'true');
        const showHiddenSettings = ref(localStorage.getItem('showHiddenSettings') === 'true');
        const useLocalCache = ref(localStorage.getItem('useLocalCache') !== 'false');
        const useCachedEndpoints = ref(localStorage.getItem('useCachedEndpoints') !== 'false');
        const wellKnownLogosOnly = ref(localStorage.getItem('wellKnownLogosOnly') !== null
            ? localStorage.getItem('wellKnownLogosOnly') === 'true'
            : wellKnownLogosOnlyGlobal);
        const enablePayByBank = ref(localStorage.getItem('enablePayByBank') === 'true');
        const isAdminUser = computed(() => {
            return checkIsAdmin(cookies);
        });
        function loadCustomer() {
            getCustomer(() => {
                if (state.customer?.employerID) {
                    getEmployer(state.customer.employerID);
                }
            });
        }
        function clearCache() {
            for (let i = localStorage.length - 1; i >= 0; i--) {
                const key = localStorage.key(i);
                if (key && key.includes('https://')) {
                    localStorage.removeItem(key);
                }
            }
            cacheCleared.value = true;
        }
        function openWhatsAppDrawer() {
            if (whatsAppEnableDrawer.value) {
                whatsAppEnableDrawer.value.openDrawer();
            }
        }
        function handleEnableWhatsApp() {
            enableWhatsApp();
        }
        function handleWhatsAppEnableDone() {
            getCustomer(null, false);
        }
        function handleLogout() {
            showLogoutConfirm.value = true;
        }
        function confirmLogout() {
            for (const key of ['token', 'user', 'pass', 'employerId']) {
                cookies?.remove(key);
            }
            localStorage.clear();
            window.location.href = 'MG_POP.html?view=logout';
        }
        watch(randomiseFigures, (val) => {
            localStorage.setItem('randomiseFigures', String(val));
            state.formatter.randomiseFigures = null;
        });
        watch(snapToSpendingCycle, (val) => {
            localStorage.setItem('snapToSpendingCycle', String(val));
        });
        watch(useLocalCache, (val) => {
            localStorage.setItem('useLocalCache', String(val));
        });
        watch(useCachedEndpoints, (val) => {
            localStorage.setItem('useCachedEndpoints', String(val));
        });
        watch(wellKnownLogosOnly, (val) => {
            localStorage.setItem('wellKnownLogosOnly', String(val));
        });
        watch(enablePayByBank, (val) => {
            localStorage.setItem('enablePayByBank', String(val));
        });
        onMounted(() => {
            loadCustomer();
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, { title: "Settings" }),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).customer
                }, null, 8, ["customer"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).customer)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, [
                                        _createElementVNode("div", _hoisted_4, [
                                            (_unref(state).employer?.logoUri)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: _unref(state).employer.logoUri,
                                                    alt: "",
                                                    class: "employer-logo"
                                                }, null, 8, _hoisted_5))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_6)),
                                            _cache[22] || (_cache[22] = _createElementVNode("span", { class: "settings-row-label" }, "Employer", -1))
                                        ]),
                                        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(state).employer?.name || ''), 1)
                                    ]),
                                    _cache[32] || (_cache[32] = _createElementVNode("div", { class: "settings-divider" }, null, -1)),
                                    _createElementVNode("div", {
                                        class: "settings-row",
                                        onClick: _cache[0] || (_cache[0] = ($event) => (_unref(router).push('/personalinformation')))
                                    }, [
                                        _createElementVNode("div", _hoisted_8, [
                                            _createVNode(_component_v_icon, {
                                                size: "24",
                                                class: "settings-icon"
                                            }, {
                                                default: _withCtx(() => _cache[23] || (_cache[23] = [
                                                    _createTextVNode("mdi-account-outline")
                                                ])),
                                                _: 1
                                            }),
                                            _cache[24] || (_cache[24] = _createElementVNode("span", { class: "settings-row-label" }, "Personal Information", -1))
                                        ]),
                                        _createElementVNode("img", {
                                            src: require('@/assets/arrow-right.png'),
                                            alt: "",
                                            class: "settings-arrow"
                                        }, null, 8, _hoisted_9)
                                    ]),
                                    _cache[33] || (_cache[33] = _createElementVNode("div", { class: "settings-divider" }, null, -1)),
                                    _createElementVNode("div", {
                                        class: "settings-row",
                                        onClick: _cache[1] || (_cache[1] = ($event) => (_unref(router).push('/notifications')))
                                    }, [
                                        _createElementVNode("div", _hoisted_10, [
                                            _createVNode(_component_v_icon, {
                                                size: "24",
                                                class: "settings-icon"
                                            }, {
                                                default: _withCtx(() => _cache[25] || (_cache[25] = [
                                                    _createTextVNode("mdi-bell-outline")
                                                ])),
                                                _: 1
                                            }),
                                            _cache[26] || (_cache[26] = _createElementVNode("span", { class: "settings-row-label" }, "Notifications Settings", -1))
                                        ]),
                                        _createElementVNode("img", {
                                            src: require('@/assets/arrow-right.png'),
                                            alt: "",
                                            class: "settings-arrow"
                                        }, null, 8, _hoisted_11)
                                    ]),
                                    _cache[34] || (_cache[34] = _createElementVNode("div", { class: "settings-divider" }, null, -1)),
                                    _createElementVNode("div", {
                                        class: "settings-row",
                                        onClick: _cache[3] || (_cache[3] = ($event) => (_unref(router).push('/setupspendinganalysis')))
                                    }, [
                                        _createElementVNode("div", _hoisted_12, [
                                            _createVNode(_component_v_icon, {
                                                size: "24",
                                                class: "settings-icon"
                                            }, {
                                                default: _withCtx(() => _cache[27] || (_cache[27] = [
                                                    _createTextVNode("mdi-refresh")
                                                ])),
                                                _: 1
                                            }),
                                            _cache[28] || (_cache[28] = _createElementVNode("span", { class: "settings-row-label" }, "Spending Cycle Settings", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_13, [
                                            _createElementVNode("img", {
                                                src: require('@/assets/info.png'),
                                                alt: "Info",
                                                class: "settings-info-icon",
                                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (spendingCycleInfoOpen.value = true), ["stop"]))
                                            }, null, 8, _hoisted_14),
                                            _createElementVNode("img", {
                                                src: require('@/assets/arrow-right.png'),
                                                alt: "",
                                                class: "settings-arrow"
                                            }, null, 8, _hoisted_15)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_16, [
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["month-view-thumb", { 'month-view-thumb--calendar': !_unref(snapToSpendingCycle) }]),
                                            "aria-hidden": "true"
                                        }, null, 2),
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: _normalizeClass(["month-view-option", { selected: _unref(snapToSpendingCycle) }]),
                                            onClick: _cache[4] || (_cache[4] = ($event) => (snapToSpendingCycle.value = true))
                                        }, "Pay Cycle", 2),
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: _normalizeClass(["month-view-option", { selected: !_unref(snapToSpendingCycle) }]),
                                            onClick: _cache[5] || (_cache[5] = ($event) => (snapToSpendingCycle.value = false))
                                        }, "Calendar", 2)
                                    ]),
                                    _cache[35] || (_cache[35] = _createElementVNode("div", { class: "settings-divider" }, null, -1)),
                                    _createElementVNode("div", _hoisted_17, [
                                        _createElementVNode("div", {
                                            class: "whatsapp-header",
                                            onClick: openWhatsAppDrawer
                                        }, _cache[29] || (_cache[29] = [
                                            _createElementVNode("div", { class: "whatsapp-icons" }, [
                                                _createElementVNode("img", {
                                                    src: _imports_0,
                                                    alt: "WhatsApp",
                                                    class: "whatsapp-icon-img"
                                                })
                                            ], -1)
                                        ])),
                                        _cache[30] || (_cache[30] = _createElementVNode("div", { class: "whatsapp-title" }, "WhatsApp AI Assistant", -1)),
                                        _cache[31] || (_cache[31] = _createElementVNode("div", { class: "whatsapp-description" }, "Your own personal financial assistant that is always available and never judgmental.", -1)),
                                        _createVNode(MGButton, {
                                            text: "How it works",
                                            outline: true,
                                            arrow: true,
                                            noCaps: true,
                                            leftAlign: true,
                                            small: true,
                                            onClick: openWhatsAppDrawer
                                        })
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_18, [
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["settings-row", { 'settings-row-disabled': cacheCleared.value }]),
                                        onClick: _cache[6] || (_cache[6] = ($event) => (!cacheCleared.value && clearCache()))
                                    }, [
                                        _createElementVNode("div", _hoisted_19, [
                                            _createElementVNode("img", {
                                                src: require('@/assets/cache.png'),
                                                alt: "",
                                                class: "settings-icon-img"
                                            }, null, 8, _hoisted_20),
                                            _cache[36] || (_cache[36] = _createElementVNode("span", { class: "settings-row-label" }, "Clear Cache", -1)),
                                            (cacheCleared.value)
                                                ? (_openBlock(), _createElementBlock("img", _hoisted_21))
                                                : _createCommentVNode("", true)
                                        ])
                                    ], 2),
                                    _cache[44] || (_cache[44] = _createElementVNode("div", { class: "settings-divider" }, null, -1)),
                                    (showHiddenSettings.value)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("div", _hoisted_22, [
                                                _createElementVNode("div", _hoisted_23, [
                                                    _createVNode(_component_v_icon, {
                                                        size: "24",
                                                        class: "settings-icon"
                                                    }, {
                                                        default: _withCtx(() => _cache[37] || (_cache[37] = [
                                                            _createTextVNode("mdi-weather-night")
                                                        ])),
                                                        _: 1
                                                    }),
                                                    _cache[38] || (_cache[38] = _createElementVNode("span", { class: "settings-row-label" }, "Dark Mode", -1))
                                                ]),
                                                _createVNode(MGToggle, {
                                                    modelValue: _unref(state).isDarkMode,
                                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(state).isDarkMode) = $event))
                                                }, null, 8, ["modelValue"])
                                            ]),
                                            _cache[39] || (_cache[39] = _createElementVNode("div", { class: "settings-divider" }, null, -1))
                                        ], 64))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_24, [
                                        _createElementVNode("div", _hoisted_25, [
                                            _createVNode(_component_v_icon, {
                                                size: "24",
                                                class: "settings-icon"
                                            }, {
                                                default: _withCtx(() => _cache[40] || (_cache[40] = [
                                                    _createTextVNode("mdi-lightning-bolt")
                                                ])),
                                                _: 1
                                            }),
                                            _cache[41] || (_cache[41] = _createElementVNode("span", { class: "settings-row-label" }, "Hide Figures", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_26, [
                                            _createElementVNode("img", {
                                                src: require('@/assets/info.png'),
                                                alt: "Info",
                                                class: "settings-info-icon",
                                                onClick: _cache[8] || (_cache[8] = ($event) => (randomiseOpen.value = true))
                                            }, null, 8, _hoisted_27),
                                            _createVNode(MGToggle, {
                                                modelValue: randomiseFigures.value,
                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((randomiseFigures).value = $event))
                                            }, null, 8, ["modelValue"])
                                        ])
                                    ]),
                                    _cache[45] || (_cache[45] = _createElementVNode("div", { class: "settings-divider" }, null, -1)),
                                    _createElementVNode("div", {
                                        class: "settings-row",
                                        onClick: handleLogout
                                    }, [
                                        _createElementVNode("div", _hoisted_28, [
                                            _createVNode(_component_v_icon, {
                                                size: "24",
                                                class: "settings-icon"
                                            }, {
                                                default: _withCtx(() => _cache[42] || (_cache[42] = [
                                                    _createTextVNode("mdi-logout")
                                                ])),
                                                _: 1
                                            }),
                                            _cache[43] || (_cache[43] = _createElementVNode("span", { class: "settings-row-label" }, "Logout", -1))
                                        ])
                                    ])
                                ]),
                                (isAdminUser.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                        _createElementVNode("div", {
                                            class: "settings-row",
                                            onClick: _cache[10] || (_cache[10] = ($event) => (_unref(router).push('/admin')))
                                        }, [
                                            _createElementVNode("div", _hoisted_30, [
                                                _createVNode(_component_v_icon, {
                                                    size: "24",
                                                    class: "settings-icon"
                                                }, {
                                                    default: _withCtx(() => _cache[46] || (_cache[46] = [
                                                        _createTextVNode("mdi-account")
                                                    ])),
                                                    _: 1
                                                }),
                                                _cache[47] || (_cache[47] = _createElementVNode("span", { class: "settings-row-label" }, "Admin Dashboard", -1))
                                            ]),
                                            _createElementVNode("img", {
                                                src: require('@/assets/arrow-right.png'),
                                                alt: "",
                                                class: "settings-arrow"
                                            }, null, 8, _hoisted_31)
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (showHiddenSettings.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                        _createElementVNode("div", _hoisted_33, [
                                            _createElementVNode("div", _hoisted_34, [
                                                _createVNode(_component_v_icon, {
                                                    size: "24",
                                                    class: "settings-icon"
                                                }, {
                                                    default: _withCtx(() => _cache[48] || (_cache[48] = [
                                                        _createTextVNode("mdi-cached")
                                                    ])),
                                                    _: 1
                                                }),
                                                _cache[49] || (_cache[49] = _createElementVNode("span", { class: "settings-row-label" }, "Use Local Cache", -1))
                                            ]),
                                            _createVNode(MGToggle, {
                                                modelValue: useLocalCache.value,
                                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((useLocalCache).value = $event))
                                            }, null, 8, ["modelValue"])
                                        ]),
                                        _cache[56] || (_cache[56] = _createElementVNode("div", { class: "settings-divider" }, null, -1)),
                                        _createElementVNode("div", _hoisted_35, [
                                            _createElementVNode("div", _hoisted_36, [
                                                _createVNode(_component_v_icon, {
                                                    size: "24",
                                                    class: "settings-icon"
                                                }, {
                                                    default: _withCtx(() => _cache[50] || (_cache[50] = [
                                                        _createTextVNode("mdi-cached")
                                                    ])),
                                                    _: 1
                                                }),
                                                _cache[51] || (_cache[51] = _createElementVNode("span", { class: "settings-row-label" }, "Use Cached Endpoints", -1))
                                            ]),
                                            _createVNode(MGToggle, {
                                                modelValue: useCachedEndpoints.value,
                                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((useCachedEndpoints).value = $event))
                                            }, null, 8, ["modelValue"])
                                        ]),
                                        _cache[57] || (_cache[57] = _createElementVNode("div", { class: "settings-divider" }, null, -1)),
                                        _createElementVNode("div", _hoisted_37, [
                                            _createElementVNode("div", _hoisted_38, [
                                                _createVNode(_component_v_icon, {
                                                    size: "24",
                                                    class: "settings-icon"
                                                }, {
                                                    default: _withCtx(() => _cache[52] || (_cache[52] = [
                                                        _createTextVNode("mdi-cached")
                                                    ])),
                                                    _: 1
                                                }),
                                                _cache[53] || (_cache[53] = _createElementVNode("span", { class: "settings-row-label" }, "Well-Known Logos Only", -1))
                                            ]),
                                            _createVNode(MGToggle, {
                                                modelValue: wellKnownLogosOnly.value,
                                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((wellKnownLogosOnly).value = $event))
                                            }, null, 8, ["modelValue"])
                                        ]),
                                        _cache[58] || (_cache[58] = _createElementVNode("div", { class: "settings-divider" }, null, -1)),
                                        _createElementVNode("div", _hoisted_39, [
                                            _createElementVNode("div", _hoisted_40, [
                                                _createVNode(_component_v_icon, {
                                                    size: "24",
                                                    class: "settings-icon"
                                                }, {
                                                    default: _withCtx(() => _cache[54] || (_cache[54] = [
                                                        _createTextVNode("mdi-bank-outline")
                                                    ])),
                                                    _: 1
                                                }),
                                                _cache[55] || (_cache[55] = _createElementVNode("span", { class: "settings-row-label" }, "Enable Pay by Bank", -1))
                                            ]),
                                            _createVNode(MGToggle, {
                                                modelValue: enablePayByBank.value,
                                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((enablePayByBank).value = $event))
                                            }, null, 8, ["modelValue"])
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_41, [
                                    _cache[59] || (_cache[59] = _createElementVNode("div", { class: "settings-footer-links" }, [
                                        _createElementVNode("a", {
                                            href: "https://www.moneyguided.com/#/terms",
                                            class: "settings-footer-link"
                                        }, "Terms & Conditions"),
                                        _createElementVNode("a", {
                                            href: "https://www.moneyguided.com/#/policy",
                                            class: "settings-footer-link"
                                        }, "Privacy Policy")
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_42, " Money Guided 2026 - Version " + _toDisplayString(_unref(state).appVersion) + " (" + _toDisplayString(parseInt(_unref(cookies)?.get('st') ?? '0')) + ", " + _toDisplayString(parseInt(_unref(cookies)?.get('sb') ?? '0')) + ") ", 1)
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(WhatsAppEnableDrawer, {
                    ref_key: "whatsAppEnableDrawer",
                    ref: whatsAppEnableDrawer,
                    phoneNumber: _unref(state).customer?.person?.mobilePhone || '',
                    onEnable: handleEnableWhatsApp,
                    onDone: handleWhatsAppEnableDone
                }, null, 8, ["phoneNumber"]),
                _createVNode(SimpleDrawerPanel, {
                    modelValue: spendingCycleInfoOpen.value,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((spendingCycleInfoOpen).value = $event)),
                    title: "Spending Cycle Settings",
                    height: "45vh",
                    closeButton: true
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_43, [
                            _createVNode(_component_v_icon, { size: "24" }, {
                                default: _withCtx(() => _cache[60] || (_cache[60] = [
                                    _createTextVNode("mdi-refresh")
                                ])),
                                _: 1
                            }),
                            _cache[61] || (_cache[61] = _createElementVNode("div", { class: "hide-drawer-description" }, [
                                _createTextVNode(" Controls how the "),
                                _createElementVNode("strong", null, "Spending Analysis"),
                                _createTextVNode(" page groups your transactions. "),
                                _createElementVNode("br"),
                                _createElementVNode("br"),
                                _createElementVNode("strong", null, "Pay Cycle"),
                                _createTextVNode(": pay date to pay date — so each period lines up with when your money actually lands. "),
                                _createElementVNode("br"),
                                _createElementVNode("strong", null, "Calendar"),
                                _createTextVNode(": 1st to month end. "),
                                _createElementVNode("br"),
                                _createElementVNode("br"),
                                _createTextVNode(" Tap the arrow to set your pay date. ")
                            ], -1)),
                            _createVNode(MGButton, {
                                text: "Close",
                                onClick: _cache[15] || (_cache[15] = ($event) => (spendingCycleInfoOpen.value = false))
                            })
                        ])
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(SimpleDrawerPanel, {
                    modelValue: randomiseOpen.value,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((randomiseOpen).value = $event)),
                    title: "Hide financial information",
                    height: "30vh",
                    closeButton: true
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_44, [
                            _createVNode(_component_v_icon, { size: "24" }, {
                                default: _withCtx(() => _cache[62] || (_cache[62] = [
                                    _createTextVNode("mdi-lightning-bolt")
                                ])),
                                _: 1
                            }),
                            _cache[63] || (_cache[63] = _createElementVNode("div", { class: "hide-drawer-description" }, "Switch this on and we'll hide your real numbers – handy if you're showing the app to someone.", -1)),
                            _createVNode(MGButton, {
                                text: "Close",
                                onClick: _cache[17] || (_cache[17] = ($event) => (randomiseOpen.value = false))
                            })
                        ])
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                        (showLogoutConfirm.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "logout-overlay",
                                onClick: _cache[21] || (_cache[21] = ($event) => (showLogoutConfirm.value = false))
                            }, [
                                _createElementVNode("div", {
                                    class: "logout-confirm",
                                    onClick: _cache[20] || (_cache[20] = _withModifiers(() => { }, ["stop"]))
                                }, [
                                    _createElementVNode("div", {
                                        class: "logout-confirm-option",
                                        onClick: confirmLogout
                                    }, "Logout"),
                                    _cache[64] || (_cache[64] = _createElementVNode("div", { class: "logout-confirm-divider" }, null, -1)),
                                    _createElementVNode("div", {
                                        class: "logout-confirm-option logout-confirm-cancel",
                                        onClick: _cache[19] || (_cache[19] = ($event) => (showLogoutConfirm.value = false))
                                    }, "Cancel")
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
